export class AnalyticBuffer {
  key: string;

  buffer: Array<any> = [];

  constructor(bufferKey: string) {
    this.key = bufferKey;

    this.setUpBuffer();
  }

  getData(): Array<any> {
    if (this.buffer.length === 0) {
      this.buffer = JSON.parse(localStorage.getItem(this.key) || "[]");
    }

    return this.buffer;
  }

  push(data: Object): void {
    this.buffer.push(data);
  }

  shift() {
    const shiftedEl = this.buffer.shift();
    this.setBufferToLocalStorage();
    return shiftedEl;
  }

  get length(): number {
    return this.buffer.length || 0;
  }

  get data(): Array<any> {
    return this.buffer;
  }

  addDataToAnalyticBuffer(data: Object): void {
    if (!this.buffer) {
      window.frisbuy.analytics = window.frisbuy.analytics || {
        [this.key]: [],
      };
    }

    if (this.buffer.length === 0) {
      this.buffer = JSON.parse(localStorage.getItem(this.key) || "[]");
    }

    this.buffer.push(data);
    localStorage.setItem(this.key, JSON.stringify(this.buffer));
  }

  setBufferToLocalStorage() {
    localStorage.setItem(this.key, JSON.stringify(this.buffer));
  }

  private setUpBuffer() {
    if (!window.frisbuy.analytics?.[this.key]) {
      window.frisbuy.analytics = window.frisbuy.analytics || {
        [this.key]: [],
      };
    }

    if (window.frisbuy.analytics[this.key].length === 0) {
      const storage = JSON.parse(localStorage.getItem(this.key) || "[]");

      window.frisbuy.analytics[this.key].push(...storage);
    }

    this.buffer = window.frisbuy.analytics[this.key];
  }
}
